const analyticsMeta = {
  permissionInfo: {
    key: "statistic",
    region: true,
  },
};

export default [
  {
    path: "/stats",
    alias: "/analytics",
    component: () => import("$views/Stats/v2"),
    children: [
      { path: "", redirect: "/stats/v2/daily" },
      { path: "v2", redirect: "/stats/v2/daily" },
      // 전체 통계 (일간)
      {
        path: "v2/daily",
        component: () => import("$views/Stats/v2/Total/Daily"),
        meta: analyticsMeta,
      },
      // 전체 통계 (월간)
      {
        path: "v2/monthly",
        component: () => import("$views/Stats/v2/Total/Monthly"),
        meta: analyticsMeta,
      },
      // 소식톡톡 통계
      {
        path: "v2/news",
        component: () => import("$views/Stats/v2/News"),
        meta: analyticsMeta,
      },
      // 두뇌톡톡/기억검사 통계
      {
        path: "v2/game_use",
        component: () => import("$views/Stats/v2/GameUse"),
        meta: analyticsMeta,
      },
      // 두뇌톡톡 콘텐츠 통계
      {
        path: "v2/game_content",
        component: () => import("$views/Stats/v2/GameContent"),
        meta: analyticsMeta,
      },
      {
        path: "v2/health_use",
        component: () => import("$views/Stats/v2/HealthUse"),
        meta: analyticsMeta,
      },
      {
        path: "v2/health_content",
        component: () => import("$views/Stats/v2/HealthContent"),
        meta: analyticsMeta,
      },
      {
        path: "v2/user",
        component: () => import("$views/Stats/v2/User"),
        meta: analyticsMeta,
      },
      {
        path: "v2/user/:id",
        component: () => import("$views/Stats/v2/User/Detail"),
        meta: analyticsMeta,
      },
    ],
  },
];
